var _rect, _path, _g, _path2, _g2, _rect2, _rect3, _circle, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 316,
    height: 196,
    viewBox: "0 0 316 196",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 315,
    height: 196,
    rx: 15,
    fill: "#38879F",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3383_21032",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 109,
    width: 72,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5039 109.232H125.783V142.415H54.5039V109.232Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3383_21032)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1484 115.983C70.9739 115.983 61.2539 119.277 61.2539 125.779C61.2539 132.34 70.9739 135.666 90.1484 135.666C109.318 135.666 119.034 132.372 119.034 125.869C119.034 119.308 109.318 115.983 90.1484 115.983ZM90.1484 142.415C81.3329 142.415 54.5039 142.415 54.5039 125.779C54.5039 110.947 74.8484 109.232 90.1484 109.232C98.9639 109.232 125.784 109.232 125.784 125.869C125.784 140.701 105.444 142.415 90.1484 142.415Z",
    fill: "#38879F"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3383_21032",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 53,
    width: 49,
    height: 48
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.2461 53.002H114.036V100.786H66.2461V53.002Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3383_21032)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1442 59.4279C80.5097 59.4279 72.6707 67.2624 72.6707 76.8969C72.6392 86.4999 80.4197 94.3299 90.0137 94.3659L90.1442 97.5789V94.3659C99.7742 94.3659 107.609 86.5269 107.609 76.8969C107.609 67.2624 99.7742 59.4279 90.1442 59.4279ZM90.1438 100.787H89.9998C76.8508 100.747 66.1993 90.0235 66.2443 76.8835C66.2443 63.721 76.9633 53.002 90.1438 53.002C103.32 53.002 114.034 63.721 114.034 76.897C114.034 90.073 103.32 100.787 90.1438 100.787Z",
    fill: "#38879F"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 149.5,
    y: 63.6406,
    width: 130,
    height: 12,
    rx: 6,
    fill: "url(#paint0_linear_3383_21032)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 149.5,
    y: 86.6406,
    width: 110,
    height: 12,
    rx: 6,
    fill: "url(#paint1_linear_3383_21032)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 280.5,
    cy: 161,
    r: 25,
    fill: "#FFBB36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M280.5 162C281.6 162 282.542 162.392 283.325 163.175C284.108 163.958 284.5 164.9 284.5 166V169H276.5V166C276.5 164.9 276.892 163.958 277.675 163.175C278.458 162.392 279.4 162 280.5 162ZM272.5 151V153H274.5V156C274.5 157.017 274.738 157.971 275.213 158.863C275.688 159.754 276.35 160.467 277.2 161C276.35 161.533 275.688 162.246 275.213 163.138C274.738 164.029 274.5 164.983 274.5 166V169H272.5V171H288.5V169H286.5V166C286.5 164.983 286.263 164.029 285.788 163.138C285.313 162.246 284.65 161.533 283.8 161C284.65 160.467 285.313 159.754 285.788 158.863C286.263 157.971 286.5 157.017 286.5 156V153H288.5V151H272.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3383_21032",
    x1: 149.826,
    y1: 69.8989,
    x2: 279.895,
    y2: 69.8989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38879F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B188",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3383_21032",
    x1: 149.776,
    y1: 92.8989,
    x2: 259.834,
    y2: 92.8989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38879F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#51B188",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingApproval);
export default __webpack_public_path__ + "static/media/pending-approval.cb0c417b3709b1eb1ea013b645dadf2e.svg";
export { ForwardRef as ReactComponent };